module.exports = __webpack_public_path__ + "img/定制化开发.454899bf.png";